//
// Comment reply Form
// ---------------------------------------------------------------------------

'use strict';

const config = {
    cancelButton: '.js-comment-reply-form-cancel',
    commentReplyForm: '.js-comment-reply-form',
    escapeKeyCode: 27
};

/**
 * When hit cancel, destroy reply form
 */
$(document).on('click touch', config.cancelButton, function (e) {
    $(e.target).closest(config.commentReplyForm).slideUp( "fast", function() {
        $(this).remove();
    });
});

/**
 * When hit escape button, destroy reply form
 */
$(document).on('keydown', config.escapeKeyCode, function (e) {
    if (e.which === config.escapeKeyCode) {
        $(e.target).closest(config.commentReplyForm).slideUp( "fast", function() {
            $(this).remove();
        });
    }
});



// WEBPACK FOOTER //
// ./src/js/components/comment-reply-form.js